import React, { HTMLAttributes } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import Image from 'components/Common/Medias/Image';

import styles from './Category.module.scss';

type PropsType = {
  label: string;
  url: string;
  thumbnail?: string | null;
  displayThumbnail: boolean;
} & HTMLAttributes<HTMLAnchorElement>;

export default function Category({
  label,
  url,
  thumbnail,
  displayThumbnail,
  className,
}: PropsType): JSX.Element {
  return (
    <Link
      to={url}
      className={classNames(styles.link, className, {
        [styles.withoutThumbnail]: !displayThumbnail,
      })}
    >
      {displayThumbnail && (
        <Image src={thumbnail ?? ''} ratio={'1'} className={styles.image} />
      )}
      <span>{label}</span>
    </Link>
  );
}
